import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export interface FormSelectStyleProps {
  margin?: string;
  flex?: string;
  hasError?: boolean;
  backgroundColor?: string;
  disabled?: boolean;
}

export const FormSelectWrap = styled.div<FormSelectStyleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.margin || "0"};
  flex: ${(p) => (p.flex ? p.flex : "")};
  flex-shrink: 0;
  width: 100%;
`;

export const FormSelectLabel = styled.label`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.greyText};
  display: block;
  margin-bottom: 8px;
  transition: all 0.3s ease;
`;

export const FormSelectStyle = styled.select<FormSelectStyleProps>`
  background: ${(props) =>
    props.disabled
      ? theme.smokeWhite
      : props.backgroundColor || theme.whiteText};
  border: 1px solid
    ${(props) => {
      if (props.hasError) return theme.redText2;
      return theme.lightGreyText;
    }};
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  width: 100%;
  height: 44px;
  color: ${theme.blackText};
  transition: all 0.2s ease;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23000000' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 8px;
  padding-right: 36px;

  &::placeholder {
    font-weight: 400;
    color: ${theme.lightBlack};
  }

  &:focus {
    outline: none;
    border: 1px solid ${theme.blueText};
    background-color: ${theme.whiteText};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: ${theme.smokeWhite};
    border-color: ${theme.lightGreyText};
  }

  option {
    padding: 8px;
    background: ${theme.whiteText};
    color: ${theme.blackText};
  }

  @media ${deviceType.mobile} {
    width: 100%;
  }
`;
